<template>
    <div>
            <div class="heading-travel-policy">
                <span :class="carAverageDailyCostObj.isActive?'tag is-success':'tag'">Standard rule</span> 
                <div class="right-content">
                    <div class="lefttext">
                        <p class="paragrapgh">Average daily cost</p>
                        <p>Trigger when the daily cost is more than
                            <span class="rule-config-variable" @click="isEdit = !isEdit">
                                {{carAverageDailyCostObj.value ? '$'+carAverageDailyCostObj.value:'N/A'}}
                                <b-icon icon="pencil" size="is-small" ></b-icon> 
                            </span>
                        </p>
                    </div>
                    <div class="allbtns">
                        <b-switch 
                            :rounded="true" 
                            :value="carAverageDailyCostObj.isActive" 
                            v-model="carAverageDailyCostObj.isActive"
                            @input="carDailyCost" 
                            :left-label="true"
                            >{{ carAverageDailyCostObj.isActive ? 'Active' : 'Inactive' }}
                        </b-switch>
                    </div>
                </div>
            </div>
            <div v-if="isEdit" class="edittravelpolicy">
                <CarDailyCost @carDailyCost="getValue" :carCost="carAverageDailyCostObj.value"/>
                <p>Enter amount</p>
                <b-button @click="saveCall">SAVE</b-button>
            </div>
    </div>
</template>
<script>
import CarDailyCost from '../CommonRules/CarDailyCost.vue';
export default {
    name:"CarAverageDailyCost",
    props: {
    value: {
      type: [Object],
    },
  },
    components:{CarDailyCost},
    data(){
        return {
          carAverageDailyCostObj:this.value?this.value:{
                    name : "carDailyCost",
                    isActive : false,
                    value : 50,
                    type:'car',
                    message:'',
          },
          isEdit:false,
          emitedValue : null
        }
    },
    methods:{
        saveCall(){
            this.isEdit = false;
            if(this.emitedValue || this.emitedValue=='') {
                this.carAverageDailyCostObj.value = this.emitedValue;
            }
        },
        getValue(val) {
          this.emitedValue = val;
        },
        carDailyCost(){
            this.carAverageDailyCostObj.message=this.buildMessage;

            this.$emit('carDailyCost',this.carAverageDailyCostObj)
        },
    },
    mounted() {
        this.carAverageDailyCostObj.type='car';
        this.carAverageDailyCostObj.message=this.buildMessage;
        this.$emit('carDailyCost',this.carAverageDailyCostObj)

    },
    computed:{
        buildMessage(){

            var string ='Trigger when the daily cost is more than ';

            return string + (this.carAverageDailyCostObj.value ? '$'+this.carAverageDailyCostObj.value:'N/A');
        }
    },
    watch: {
    value: {
      handler(newVal, prevVal) {
        this.carAverageDailyCostObj = this.value;
        this.carAverageDailyCostObj.type='car';
        this.carAverageDailyCostObj.message=this.buildMessage;
        this.$emit('carDailyCost',this.carAverageDailyCostObj)

      },
      deep: true,
    },
  },
}
</script>